const cardDueMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{4})/, '$1/$2')
    .replace(/(.{7})\d+?$/, '$1');
};

export default cardDueMask;
